module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARTIN’S")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("APERBACKS")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ITLES")]), _c('br'), _vm._v("B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Y")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AITLIN")]), _vm._v(" K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ITTREDGE")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Night Life")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Pure Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Second Skin")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-258089de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abouttheauthor.vue
// module id = 60
// module chunks = 0